import VMCard from "./VMCard";
import NavigatingTooltip from "./NavigatingTooltip";

const ComposerAtoms = {
  VMCard,
  NavigatingTooltip,
};

export default ComposerAtoms;